export default {
   JWTTOKEN: 'api/v1/tokenGenrate',
   SIGNIN: 'api/v1/userAuth/bmLogin',
   AUDITLIST: 'api/v1/audit/getBmAuditList',
   ACTIONABLEDETAIL: 'api/v1/question/getActionableDetail',
   ACTIONABLE_SUBMIT: 'api/v1/question/actionableSubmit',
   QUESTIONLIST: 'api/v1/question/bmQuestionlist',
   CAPTURINIMAGE: 'api/v1/question/updateCaptureimage',
   GETIMAGEREQUEST:'api/v1/question/getImagedata',
   AGORA_TOKEN:'/api/v1/audit/getAgoraToken',
   LOGOUT:"api/v1/userAuth/logout"
   
}